var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('div',{attrs:{"id":"container"}},[_c('create-business-location-component',{attrs:{"siteId":this.siteId,"isUpdateMode":true}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }